import { render } from "./dropdown-select.vue?vue&type=template&id=ddbec7ba"
import script from "./dropdown-select.vue?vue&type=script&lang=js"
export * from "./dropdown-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__